import ModalTAField from "./ModalTextAreaField";

import {
  Modal,
  ModalHeader,
  ModalHeading,
  ModalFooter,
  ModalFooterActions,
} from "@twilio-paste/modal";
import { createRef } from "react";
import { Box, ModalBody } from "@twilio-paste/core";
import { Button } from "@twilio-paste/button";
import React, { useState } from "react";
import { User } from "@twilio/conversations";
import { conversationsMap } from "../../conversations-objects";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  successNotification,
  unexpectedErrorNotification,
} from "../../helpers";
import { actionCreators, AppState } from "../../store";

interface BulkSmsModalProps {
  isModalOpen: boolean;
  handleClose: () => void;
  user?: User;
  title: string;
  //modalBody: JSX.Element;
  //modalFooter?: JSX.Element;
}
//console.log(conversationsMap.slice(-1));
const BulkSmsModal: React.FC<BulkSmsModalProps> = (
  props: BulkSmsModalProps
) => {
  const nameInputRef = createRef<HTMLInputElement>();
  const [setMessage, setsetMessage] = useState("");

  const dispatch = useDispatch();

  const { updateLoadingState, addNotifications } = bindActionCreators(
    actionCreators,
    dispatch
  );

  const loadingStatus = useSelector((state: AppState) => state.loadingStatus);

  //const loadingProgress = useSelector((state: AppState) => state.progressState);

  const handleClick2 = async () => {
    updateLoadingState(true);
    try {
      //let i = 0;
      conversationsMap.forEach(async (ele, i) => {
        //for (const ele of conversationsMap) {
        //const currisd = await i++;
        //UpdateProgress(await currisd);
        const sdkConvo = ele;

        const newMessageBuilder = sdkConvo.prepareMessage().setBody(setMessage);
        const messageIndex = await newMessageBuilder.build().send();
        /* try {
          await sdkConvo.advanceLastReadMessageIndex(messageIndex ?? 0);
        } catch (err1) {
          unexpectedErrorNotification(err1.message, addNotifications);
          console.log("error");
          throw err1;
        } */
        //console.log(i);
        //console.log("currisd:" + currisd);
      }); //delete this parenthesis if you are doing for loop

      //UpdateProgress(0);
      updateLoadingState(false);
      props.handleClose();
      successNotification({
        message: "Messages sent to " + conversationsMap.size + " contacts.",
        addNotifications, /// has error on toast id : cannot number expects string
      });
    } catch (err) {
      console.log("error");
    }
  };

  return (
    <>
      <Modal
        ariaLabelledby="add-convo-modal"
        isOpen={props.isModalOpen}
        onDismiss={() => props.handleClose()}
        initialFocusRef={nameInputRef}
        size="default"
        //handleClose={() => props.handleClose()}
        //isModalOpen={props.isModalOpen}
      >
        <ModalHeader>
          <ModalHeading as="h3">{props.title}</ModalHeading>
        </ModalHeader>
        <ModalBody>
          <Box
            as="form"
            onKeyPress={async (e) => {
              if (e.key === "Enter") {
                handleClick2;
              }
            }}
          >
            <ModalTAField
              isFocused={true}
              label="Message"
              onChange={setsetMessage}
              maxLength={255}
              disabled={loadingStatus}
            />
            <br></br>
          </Box>
        </ModalBody>
        <ModalFooter>
          <ModalFooterActions justify="start">
            <Button
              variant="secondary"
              onClick={() => {
                props.handleClose();
              }}
            >
              Close
            </Button>
          </ModalFooterActions>
          <ModalFooterActions>
            {/* <Button
                loading={isLoading}
                variant="primargy"
                onClick={handleClick}
              >
                Send
              </Button> */}
            <Button
              loading={loadingStatus}
              disabled={
                !setMessage || conversationsMap.size == 0 ? true : false
              }
              variant="primary"
              onClick={handleClick2}
            >
              Send
            </Button>
          </ModalFooterActions>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default BulkSmsModal;
